import {
  useEffect,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  LikeIcon,
  CommentIcon,
  RepostIcon,
  SaveIcon,
  ShareIcon,
  SubscribeIcon
} from 'assets/icons'
import {
  NotificationSections,
  PENDING,
  SUCCEEDED
} from 'utils/constants'
import {
  getEngagementItems,
  setEngagementItems,
  setGetEngagementItemsStatus,
  setNotificationSectionPage,
  setSelectedEngagementType
} from 'store'
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Center,
  Text,
  Stack,
  Spinner
} from '@chakra-ui/react'
import { capitalizeFirst } from 'utils/helpers'
import { COLORS } from 'utils/styles'

export const Engagements = ({
  engagementTypes,
  getBlogPreferenceStatus,
  getEngagementItemsStatus,
  getEventDataStatus,
  getPostsStatus,
  getProfileItemStatus,
  getSavedEventsStatus,
  lastSeenEngagementStatus,
  postMakeNotificationSeenAllStatus,
  rowTitle,
  singleMarkerUpdateStatus
}) => {
  const dispatch = useDispatch()
  const [engagementCount, setEngagementCount] = useState(0)
  const [selectedEngType, setSelectedEngType] = useState('')

  const iconMap = {
    likes: LikeIcon,
    comments: CommentIcon,
    reposts: RepostIcon,
    shares: ShareIcon,
    subscriptions: SubscribeIcon,
    saves: SaveIcon
  }

  const handleNewEngCount = () => {
    let total = 0
    engagementTypes?.forEach((item) => {
      total += item?.newNotifs
    })

    setEngagementCount(total)
  }

  useEffect(() => {
    if (getEngagementItemsStatus === SUCCEEDED) {
      dispatch(setNotificationSectionPage({
        key: NotificationSections.ENGAGEMENT_ITEM_LIST,
        title: selectedEngType === 'Saves' ? 'Saved' : selectedEngType
      }))
      dispatch(setSelectedEngagementType(selectedEngType))
      dispatch(setGetEngagementItemsStatus(0))
    }
  }, [getEngagementItemsStatus])

  useEffect(() => {
    if (lastSeenEngagementStatus === SUCCEEDED) {
      handleNewEngCount()
    }
  }, [lastSeenEngagementStatus])

  useEffect(() => handleNewEngCount(), [])

  return (
    <Card key="engagements" boxShadow="none" marginTop="0px !important" background="#c4c3c7">
      <CardHeader display="flex" alignItems="center" padding="0 25px" background="#feeb88">
        <Box textAlign="left" paddingRight="10px">
          {rowTitle}
        </Box>
        {engagementCount > 0 && (
          <Stack direction="row" alignItems="center">
            <Box
              textAlign="center"
              background={COLORS.gold}
              width={engagementCount > 99 ? '25px' : '17px'}
              height="17px"
              borderRadius="full"
              position="relative"
            >
              <Box
                fontSize="12px"
                fontWeight={500}
                transform="translate(-50%, -50%)"
                top="50%"
                left="50%"
                position="absolute"
              >
                {engagementCount > 99 ? '99+' : engagementCount}
              </Box>
            </Box>
          </Stack>
        )}
      </CardHeader>

      <CardBody
        padding="5px"
        minHeight="130px"
        maxHeight="130px"
        verflow="hidden"
      >
        <Box
          sx={{
            overflowX: 'auto',
            display: 'flex',
            flexDirection: 'row',
            gap: '0px',
            margin: '0 5px'
          }}
          css={{
            '&::-webkit-scrollbar': {
              width: '4px',
              height: '10px',
              display: 'block'
            },
            '&::-webkit-scrollbar-track': {
              width: '6px'
            },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: '24px',
              background: 'rgba(255, 215, 0, 1)'
            }
          }}
        >
          {engagementTypes?.map((item) => {
            const IconComponent = iconMap[item.type] || LikeIcon
            let viewBox = ''

            if (item.type === 'subscriptions') {
              viewBox = '2 2 20 20'
            }

            if (item.type === 'saves') {
              viewBox = '2 2 22 22'
            }

            return (
              <Stack
                key={item.id}
                minWidth="120px"
                overflow="hidden"
              >
                <Box
                  as="button"
                  key={item.id}
                  backgroundColor={COLORS.white}
                  maxWidth="108px"
                  border="solid black 1px"
                  borderRadius="5px"
                  minHeight="108px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                  position="relative"
                  marginTop="5px"
                  pointerEvents={
                    getPostsStatus === PENDING
                    || postMakeNotificationSeenAllStatus === PENDING
                    || getProfileItemStatus === PENDING
                    || getEventDataStatus === PENDING
                    || getEngagementItemsStatus === PENDING
                    || getBlogPreferenceStatus === PENDING
                    || singleMarkerUpdateStatus === PENDING
                    || getSavedEventsStatus === PENDING
                    || sessionStorage.getItem('openProfileAfterAnimation')
                    || sessionStorage.getItem('openEventAfterAnimation')
                      ? 'none'
                      : 'auto'
                  }
                  opacity={
                    getPostsStatus === PENDING
                    || postMakeNotificationSeenAllStatus === PENDING
                    || getProfileItemStatus === PENDING
                    || getEventDataStatus === PENDING
                    || getEngagementItemsStatus === PENDING
                    || getBlogPreferenceStatus === PENDING
                    || singleMarkerUpdateStatus === PENDING
                    || getSavedEventsStatus === PENDING
                    || sessionStorage.getItem('openProfileAfterAnimation')
                    || sessionStorage.getItem('openEventAfterAnimation')
                      ? 0.7
                      : 1
                  }
                  onClick={() => {
                    setSelectedEngType('')

                    let waitTime = 0
                    if (document.querySelector('#chakra-modal-event-drawer')) {
                      document.querySelector('#force-close-event-drawer')?.click()
                      dispatch(getEngagementItems.pending())
                      waitTime = 900
                    }

                    setTimeout(() => {
                      dispatch(setEngagementItems([]))
                      const capitalizedTitle = capitalizeFirst(item.type)

                      setSelectedEngType(capitalizedTitle)
                      dispatch(getEngagementItems({
                        type: capitalizedTitle,
                        limit: Math.ceil(window.innerHeight / 80)
                      }))
                    }, waitTime)
                  }}
                >
                  {
                    getEngagementItemsStatus === PENDING
                    && item.type === selectedEngType.toLowerCase()
                      ? (
                        <Center position="absolute">
                          <Spinner
                            key={item.id}
                            width="80px"
                            height="80px"
                            position="sticky"
                            zIndex={5}
                          />
                        </Center>
                      ) : ''
                  }

                  <Text
                    opacity={item.newNotifs ? '1' : '0'}
                    position="absolute"
                    top="0"
                    right="2"
                    fontSize="20px"
                    color={COLORS.red}
                  >
                    {item.newNotifs}
                  </Text>
                  <Text opacity="0">
                    {item.newNotifs}
                  </Text>

                  <IconComponent
                    fill="transparent"
                    stroke="gradient"
                    strokeGradient={[
                      COLORS.metallicGold,
                      COLORS.darkGray
                    ]}
                    width="50"
                    height="50"
                    {...(viewBox === '' ? {} : { viewBox })}
                  />

                  <Text fontSize="20px">
                    {capitalizeFirst(item.type === 'subscriptions' ? 'subs' : item.type)}
                  </Text>
                </Box>
              </Stack>
            )
          })}
        </Box>
      </CardBody>
    </Card>
  )
}
